import { render, staticRenderFns } from "./EditProductMapping.vue?vue&type=template&id=01593534"
import script from "./EditProductMapping.vue?vue&type=script&lang=js"
export * from "./EditProductMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports